const ROOT = "TableComponent";
const INSERT_TABLE_MODAL = "addTableModal";
const INSERT_TABLE_MODAL_ROWS_INPUT = "rowCount";
const INSERT_TABLE_MODAL_COLUMNS_INPUT = "columnCount";
const INSERT_TABLE_MODAL_ERROR_MESSAGE = "insertTableModalErrorMessage";
const TABLE_PLUS_BUTTON = "tablePlusButton";
export {
  INSERT_TABLE_MODAL,
  INSERT_TABLE_MODAL_COLUMNS_INPUT,
  INSERT_TABLE_MODAL_ERROR_MESSAGE,
  INSERT_TABLE_MODAL_ROWS_INPUT,
  ROOT,
  TABLE_PLUS_BUTTON
};
//# sourceMappingURL=dataHooks.js.map
